import React, { Component } from 'react';
import properties from '../../../modules/ajio-util/properties';

export default class Footer extends Component {
  render() {
    const { customerCare: { formatted = '', unformatted = '' } = {} } = this.props;
    return (
      <div className="checkout-flow-footer" id="checkoutFlowFooter" key="checkout-flow-footer">
        <div className="need-help-section" id="needHelp">
          <p className="need-help" tabIndex={0}>Need Help ?</p>
          <p className="call-us-information" tabIndex={0}>
            Call 1800-889-9991
            <a href={`tel:${formatted}`} className="phone-link">
              {unformatted}
            </a>
            or visit the
            <a href={`${properties.getProperty('parentUrl')}/help/faq`} className="faq">
              FAQ
            </a>
            page for any queries. 
          </p>
        </div>

        <div className="footer-area">
          <div className="method-list">
            <p className="footer-headline payment-method-label" tabIndex={0}>Payment Methods</p>
            <ul className="payment-method-list">
              <li className="payment-method-list-item" aria-label='Net banking' tabIndex={0}>
                <span className="ic-netbank" />
              </li>
              <li className="payment-method-list-item" aria-label='Visa' tabIndex={0}>
                <span className="ic-visa" />
              </li>
              <li className="payment-method-list-item" aria-label='Master card' tabIndex={0}>
                <span className="ic-mastercard" />
              </li>
              <li className="payment-method-list-item" aria-label='Amex' tabIndex={0}>
                <span className="ic-amex" />
              </li>
              <li className="payment-method-list-item" aria-label='Cash on delivery' tabIndex={0}>
                <span className="ic-cod" />
              </li>
              <li className="payment-method-list-item" aria-label='Jio money' tabIndex={0}>
                <span className="ic-jiomoney" />
              </li>
            </ul>
          </div>
          <div className="footer-secure-system">
            <p className="footer-headline" tabIndex={0}>Secure Systems</p>
            <div className="secure-list">
              <ul className="payment-method-list">
                <li className="payment-method-list-item" aria-label='SSL' tabIndex={0}>
                  <span className="ic-ssl" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
